// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"172":"c4325fd9","206":"4e6e2d77"}[chunkId] + ".chunk.js";
};